/**
 * Centralizovani API error/success kodovi i korisničke poruke.
 * Mapiranje backend `code` vrednosti i poznatih EN poruka na srpske poruke za UI.
 */

export const API_ERROR_CODES = {
  NoPermissionEx: 'NoPermissionEx',
  ForbiddenException: 'ForbiddenException',
  UserNotCsoLeadEx: 'UserNotCsoLeadEx',
  UserNotInCsoEx: 'UserNotInCsoEx',
  BadRequestException: 'BadRequestException',
  AccountNotFoundEx: 'AccountNotFoundEx',
  AccountRoleNotFoundEx: 'AccountRoleNotFoundEx',
  ActionPlanNotFoundEx: 'ActionPlanNotFoundEx',
  ActivityNotFoundEx: 'ActivityNotFoundEx',
  ActivityProposalNotFoundEx: 'ActivityProposalNotFoundEx',
  AdditionalOrgInfoNotFoundEx: 'AdditionalOrgInfoNotFoundEx',
  ChangeLeadInOrganizationEx: 'ChangeLeadInOrganizationEx',
  DocumentNotFoundEx: 'DocumentNotFoundEx',
  InvalidateAccountInOrganizationRequestEx: 'InvalidateAccountInOrganizationRequestEx',
  InvalidRoleHeaderEx: 'InvalidRoleHeaderEx',
  NoTemplateForParamsEx: 'NoTemplateForParamsEx',
  NoticeNotFoundEx: 'NoticeNotFoundEx',
  NotificationNotFoundEx: 'NotificationNotFoundEx',
  ObligationModeratorNotFoundEx: 'ObligationModeratorNotFoundEx',
  ObligationNotFoundEx: 'ObligationNotFoundEx',
  ObligationProposalNotFoundEx: 'ObligationProposalNotFoundEx',
  ObligationStatusNotFoundEx: 'ObligationStatusNotFoundEx',
  OrganizationNotActiveEx: 'OrganizationNotActiveEx',
  OrganizationOnObligationNotFoundEx: 'OrganizationOnObligationNotFoundEx',
  OrganizationRegisterNotFoundEx: 'OrganizationRegisterNotFoundEx',
  SeoNotFoundEx: 'SeoNotFoundEx',
  VerifyAccountInOrganizationRequestEx: 'VerifyAccountInOrganizationRequestEx',
  NotFoundException: 'NotFoundException',
  AccountInOrganizationRequestExistsEx: 'AccountInOrganizationRequestExistsEx',
  OrganizationExistsEx: 'OrganizationExistsEx',
  OrganizationNotVerifiedEx: 'OrganizationNotVerifiedEx',
  OrganizationRegisterExistsEx: 'OrganizationRegisterExistsEx',
  ConflictException: 'ConflictException',
  NoUserEx: 'NoUserEx',
  InternalServerException: 'InternalServerException',
};

/** Poruka kada OCD već postoji (409 OrganizationExistsEx). */
export const ORGANIZATION_EXISTS_EX_MESSAGE =
  'Организација са тим називом већ постоји или је захтев већ поднет.';

/** Poruka kada institucija već postoji (409 OrganizationExistsEx). */
export const INSTITUTION_EXISTS_EX_MESSAGE =
  'Институција са тим називом већ постоји или је захтев већ поднет.';

/** Mapiranje backend `code` → korisnička poruka. */
export const API_ERROR_MESSAGES = {
  [API_ERROR_CODES.NoPermissionEx]: 'Немате дозволу за ову операцију.',
  [API_ERROR_CODES.UserNotCsoLeadEx]:
    'Корисник није вођа (lead) у организацији. Ова акција је доступна само вођи организације.',
  [API_ERROR_CODES.UserNotInCsoEx]: 'Корисник није члан тражене организације.',
  [API_ERROR_CODES.AccountNotFoundEx]: 'Кориснички налог није пронађен.',
  [API_ERROR_CODES.AccountRoleNotFoundEx]:
    'Налог нема одговарајућу улогу за тражену операцију.',
  [API_ERROR_CODES.ActionPlanNotFoundEx]: 'Акциони план није пронађен.',
  [API_ERROR_CODES.ActivityNotFoundEx]: 'Активност није пронађена.',
  [API_ERROR_CODES.ActivityProposalNotFoundEx]: 'Предлог активности није пронађен.',
  [API_ERROR_CODES.ObligationNotFoundEx]: 'Обавеза није пронађена.',
  [API_ERROR_CODES.ObligationProposalNotFoundEx]: 'Предлог обавезе није пронађен.',
  [API_ERROR_CODES.ObligationStatusNotFoundEx]: 'Статус обавезе није пронађен.',
  [API_ERROR_CODES.ObligationModeratorNotFoundEx]: 'Модератор обавезе није пронађен.',
  [API_ERROR_CODES.AdditionalOrgInfoNotFoundEx]:
    'Додатни подаци о организацији нису пронађени.',
  [API_ERROR_CODES.OrganizationNotActiveEx]:
    'Организација не постои или тренутно није активна.',
  [API_ERROR_CODES.OrganizationOnObligationNotFoundEx]:
    'Организација није део ове обавезе.',
  [API_ERROR_CODES.OrganizationRegisterNotFoundEx]:
    'Тип организације (регистар) није пронађен у систему.',
  [API_ERROR_CODES.ChangeLeadInOrganizationEx]:
    'Активан приступ за дати налог и организацију није пронађен.',
  [API_ERROR_CODES.InvalidateAccountInOrganizationRequestEx]:
    'Захтев за поништавање приступа налогу у организацији није пронађен.',
  [API_ERROR_CODES.VerifyAccountInOrganizationRequestEx]:
    'Захтев за верификацију приступа налогу у организацији није пронађен.',
  [API_ERROR_CODES.DocumentNotFoundEx]: 'Документ није пронађен.',
  [API_ERROR_CODES.NoticeNotFoundEx]: 'Објава није пронађена.',
  [API_ERROR_CODES.NotificationNotFoundEx]: 'Обавештење није пронађено.',
  [API_ERROR_CODES.SeoNotFoundEx]: 'SEO метаподаци нису пронађени за дати ентитет.',
  [API_ERROR_CODES.InvalidRoleHeaderEx]:
    'Недостаје X-Role заглавље. Освежите страницу и покушајте поново.',
  [API_ERROR_CODES.NoTemplateForParamsEx]:
    'Email шаблон није пронађен. Језик налога можда није подржан.',
  [API_ERROR_CODES.AccountInOrganizationRequestExistsEx]:
    'Захтев за приступ овој организацији је већ послат.',
  [API_ERROR_CODES.OrganizationExistsEx]: ORGANIZATION_EXISTS_EX_MESSAGE,
  [API_ERROR_CODES.OrganizationNotVerifiedEx]:
    'Организација још увек није верификована и одобрена.',
  [API_ERROR_CODES.OrganizationRegisterExistsEx]:
    'Регистар са тим називом је већ активан.',
  [API_ERROR_CODES.NoUserEx]: 'Сесија није валидна. Молимо пријавите се поново.',
  [API_ERROR_CODES.InternalServerException]:
    'Дошло је до грешке на серверу. Молимо покушајте поново.',
};

export const API_ERROR_MESSAGE_BY_TEXT = {
  'Missing bearer token': 'Нисте пријавлени. Молимо пријавите се.',
  'Invalid or expired token':
    'Сесија је истекла или токен није важећи. Молимо пријавите се поново.',
  Unauthorized: 'Нисте овлашћени. Молимо пријавите се.',
  Forbidden: 'Немате дозволу за ову операцију.',
  "You don't have permission for this operation.": 'Немате дозволу за ову операцију.',
  "User cannot alter another user's obligation draft.":
    'Не можете мењати нацрт обавезе другог корисника.',
  'Only admin can finalize an obligation proposal by mediation.':
    'Само администратор може финализовати предлог обавезе посредовањем.',
  'User is not lead within the organization.':
    'Корисник није вођа (lead) у организацији.',
  'User is not in the requested CSO.': 'Корисник није члан тражене организације.',
  'Type mismatch': 'Неисправан тип податка у захтеву.',
  'Cannot parse enum value.':
    'Неисправна вредност — дозвољене вредности нису препознате.',
  'Only draft obligations can be altered through draft endpoints.':
    'Само нацрти обавеза могу се мењати кроз ендпоинт за нацрте.',
  'Draft is missing required fields for submit.':
    'Нацрт нема сва обавезна поља за слање.',
  "Can't alter other fields that aren't for your role.":
    'Не можете мењати поља која нису дозволена за вашу улогу.',
  "og_image must be an absolute URL or a relative path starting with '/'.":
    'OG слика мора бити апсолутни URL или релативна путанја која почиње са „/“.',
  'canonical_url must be a valid absolute URL.':
    'Канонски URL мора бити исправан апсолутни URL.',
  'Field must be either null or not blank.':
    'Поље мора бити празно или попунјено — делимична вредност није дозволена.',
  'Field must be either null or not empty.':
    'Поље мора бити празно или имати садржај — делимична вредност није дозволена.',
  'No account found for provided id': 'Кориснички налог није пронађен.',
  "Account doesn't have appropriate role":
    'Налог нема одговарајућу улогу за тражену операцију.',
  'Action plan not found.': 'Акциони план није пронађен.',
  'Activity not found.': 'Активност није пронађена.',
  'Activity proposal with the inquired ID not found.': 'Предлог активности није пронађен.',
  'No additional info found for organization id':
    'Додатни подаци о организацији нису пронађени.',
  'Active access for provided account and organization not found':
    'Активан приступ за дати налог и организацију није пронађен.',
  'Document not found.': 'Документ није пронађен.',
  'Request for invalidation of provided account and organization is not found':
    'Захтев за поништавање приступа налогу у организацији није пронађен.',
  'X-Role header is missing':
    'Недостаје X-Role заглавље. Освежите страницу и покушајте поново.',
  'Could not find email template. Provided / account-defined language is probably not supported.':
    'Email шаблон није пронађен. Језик налога можда није подржан.',
  'Notice not found.': 'Објава није пронађена.',
  'Notification not found.': 'Обавештење није пронађено.',
  'Valid Obligation moderator not found.': 'Модератор обавезе није пронађен.',
  'Obligation not found.': 'Обавеза није пронађена.',
  'Obligation proposal with the inquired ID not found.': 'Предлог обавезе није пронађен.',
  'Obligation status not found.': 'Статус обавезе није пронађен.',
  'Organization with provided id does not exist or currently is not active':
    'Организација не постои или тренутно није активна.',
  'Organization is not part of this obligation.': 'Организација није део ове обавезе.',
  'Register with provided id not found in database':
    'Тип организације (регистар) није пронађен у систему.',
  'SEO metadata not found for provided entity.':
    'SEO метаподаци нису пронађени за дати ентитет.',
  'Request for verification of provided account and organization is not found':
    'Захтев за верификацију приступа налогу у организацији није пронађен.',
  'Request for access to organization of provided account and organization already exists':
    'Захтев за приступ овој организацији је већ послат.',
  'Organization with provided name, number and register already registered':
    ORGANIZATION_EXISTS_EX_MESSAGE,
  'Organization with provided id is not verified and approved':
    'Организација још увек није верификована и одобрена.',
  'Register with provided name already active': 'Регистар са тим називом је већ активан.',
  'No user found in security context': 'Сесија није валидна. Молимо пријавите се поново.',
  'No authenticated JWT in SecurityContext': 'Сесија није валидна. Молимо пријавите се поново.',
  'No value present': 'Дошло је до грешке на серверу. Молимо покушајте поново.',
};

export const API_ERROR_MESSAGE_PATTERNS = [
  { pattern: /\bmust not be null\b/i, message: 'Обавезно поље није попунјено.' },
  { pattern: /\bmust not be blank\b/i, message: 'Обавезно поље не сме бити празно.' },
  { pattern: /\bmust not be empty\b/i, message: 'Обавезно поље мора садржати бар једну вредност.' },
  { pattern: /\bmust be a well-formed email address\b/i, message: 'E-mail адреса није исправног формата.' },
  {
    pattern: /\bsize must be between (\d+) and (\d+)\b/i,
    message: (match) => `Вредност мора имати између ${match[1]} и ${match[2]} карактера.`,
  },
  {
    pattern: /\bmust match "([^"]+)"\b/i,
    message: (match) => `Вредност не одговара дозвољеном формату (${match[1]}).`,
  },
  { pattern: /\bmust be null\b/i, message: 'Ово поље мора бити празно за вашу улогу.' },
  {
    pattern: /^Invalid quartal format:\s*(.+)$/i,
    message: (match) => `Неисправан формат квартала: ${match[1]}.`,
  },
  {
    pattern: /^Invalid quarter:\s*(.+)$/i,
    message: (match) => `Неисправан квартал: ${match[1]}.`,
  },
  {
    pattern: /^Invalid ordinal:\s*(.+)$/i,
    message: (match) => `Неисправан редни број: ${match[1]}.`,
  },
  {
    pattern: /^Unknown name:\s*(.+)$/i,
    message: (match) => `Непозната вредност: ${match[1]}.`,
  },
  {
    pattern: /^No (.+) subject translation for the type (.+)$/i,
    message: () => 'Превод за email обавештење није доступан. Контактирајте администратора.',
  },
  {
    pattern: /unique constraint/i,
    message: 'Вредност већ постои у систему. Проверите унете податке.',
  },
  {
    pattern: /exclusion constraint/i,
    message: 'Унети подаци нису у складу са правилима система.',
  },
  {
    pattern: /foreign key|key-not-present|referenced entity/i,
    message: 'Повезани ресурс није пронађен. Освежите страницу и покушајте поново.',
  },
];

export const API_HTTP_STATUS_MESSAGES = {
  400: 'Неисправан захтев. Проверите унете податке.',
  401: 'Сесија је истекла. Молимо пријавите се поново.',
  403: 'Немате дозволу за ову операцију.',
  404: 'Тражени ресурс није пронађен.',
  409: 'Конфликт подака — ресурс већ постои или није у одговарајућем станју.',
  500: 'Дошло је до грешке на серверу. Молимо покушајте поново.',
};

export const API_SUCCESS_MESSAGES = {
  ORG_REGISTRATION_SUBMITTED:
    'Пријава организације је успешно поднета. Приступ ће бити омогућен након верификације од стране администратора.',
  INST_REGISTRATION_SUBMITTED:
    'Пријава институције је успешно поднета. Приступ ће бити омогућен након верификације од стране администратора.',
  ACCESS_REQUEST_SENT: 'Захтев за приступ је успешно послат.',
  INST_ACCESS_REQUEST_SENT: 'Захтев за приступ институцији је успешно послат.',
};

export const ENTITY_FORM_FIELD_LABELS = {
  name: {
    org: 'Назив организације',
    inst: 'Назив институције',
  },
  contactFirstName: 'Име контакт особе',
  contactLastName: 'Презиме контакт особе',
  userEmail: 'E-mail контакт особе',
  userPhone: 'Телефон контакт особе',
};

export const ENTITY_FORM_VALIDATION_GROUP_MESSAGES = {
  REQUIRED_PREFIX: 'Недостају обавезна поља:',
  INVALID_EMAIL: 'E-mail адреса није валидног формата.',
  INVALID_PHONE: 'Број телефона није валидног формата.',
  PHONE_TOO_LONG: 'Број телефона је предугачак.',
};

export const ENTITY_FORM_VALIDATION_MESSAGES = {
  ORG_REGISTER_UNAVAILABLE:
    'Регистрација нових организација тренутно није омогућена. Молимо контактирајте администратора.',
  INST_REGISTER_UNAVAILABLE:
    'Регистрација нових институција тренутно није омогућена. Молимо контактирајте администратора.',
  SUBMIT_ERROR: 'Грешка при подношењу пријаве.',
};
